import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { jwtDecode } from 'jwt-decode';
import { Observable, of, tap } from 'rxjs';

import { COMPANY_API_ROUTE_BASE } from '@constants/api-routes.constant';
import { DateHelper } from '@helpers/date.helper';

export interface GemToken {
  expired_at: string;
}

@Injectable({
  providedIn: 'root'
})
export class GemAuthService {
  private token: string = null;

  constructor(private readonly http: HttpClient) {}

  getToken(): Observable<string> {
    if (this.isTokenExpired()) {
      return this.retrieveToken().pipe(tap((token: string) => (this.token = token)));
    } else {
      return of(this.token);
    }
  }

  removeToken(): void {
    this.token = null;
  }

  private isTokenExpired(): boolean {
    if (!this.token) {
      return true;
    }

    const tokenExpireAt = DateHelper.fromUtc(this.decodeToken().expired_at) || new Date();

    return !(tokenExpireAt.valueOf() > new Date().valueOf());
  }

  private retrieveToken(): Observable<string> {
    const url = `${COMPANY_API_ROUTE_BASE}/gem/token`;

    return this.http.post(url, null, { responseType: 'text' });
  }

  private decodeToken(): GemToken {
    return jwtDecode(this.token);
  }
}
